
var id = "templateMessage";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"templateMessage\"><defs><style type=\"text/css\"></style></defs><path d=\"M688.3 411.9c-29 0-51.5 22.5-51.5 51.5s22.5 51.5 51.5 51.5 51.5-22.5 51.5-51.5c0-28.9-22.6-51.5-51.5-51.5z m199.6-299.4H137.7c-41.9 0-74.1 32.2-74.1 74.1v550.6c0 41.9 32.2 74.1 74.1 74.1h273.7l99.8 99.8 99.8-99.8h273.7c41.9 0 74.1-32.2 74.1-74.1V186.6c6.4-41.9-29.1-74.1-70.9-74.1z m0 569.9c0 29-22.5 51.5-51.5 51.5H588.5l-77.3 77.3-77.3-77.3H179.6c-25.8 0-45.1-19.3-45.1-45.1V231.6c0-25.8 19.3-45.1 45.1-45.1h656.8c25.8 0 48.3 22.5 48.3 48.3l3.2 447.6zM340.5 411.9c-29 0-51.5 22.5-51.5 51.5s22.5 51.5 51.5 51.5 51.5-22.5 51.5-51.5c-3.2-28.9-25.7-51.5-51.5-51.5z m173.9 0c-29 0-51.5 22.5-51.5 51.5s22.5 51.5 51.5 51.5 51.5-22.5 51.5-51.5c-3.2-28.9-22.5-51.5-51.5-51.5z\" p-id=\"4220\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
